import z from 'zod';

export const FeatureFlagsConfigSchema = z.object({
  labOrdersEnabled: z.boolean(),
  inHouseLabsEnabled: z.boolean(),
  radiologyEnabled: z.boolean(),
  nursingOrdersEnabled: z.boolean(),
  supervisorApprovalEnabled: z.boolean(),
  demoVisitsEnabled: z.boolean(),
  easyChartEnabled: z.boolean().optional(),
  globalTemplatesEnabled: z.boolean(),
  legacyDataEnabled: z.boolean(),
  mailingPaperStatementsEnabled: z.boolean(),
  automatedPatientOutreachEnabled: z.boolean(),
  legacyPatientFollowupsEnabled: z.boolean(),
  skipSendingVisitNoteToPatientPortalEnabled: z.boolean(),
  sendgridEnabled: z.boolean(),
  hideRegisterAnotherPatient: z.boolean().optional(),
  ottehrBillingInvoicingEnabled: z.boolean().optional(),
  // When false, the patient-facing booking flow only sees BOOKING_CONFIG
  // categories — FHIR-managed (admin-registered) HealthcareService categories
  // are suppressed. Lets a customer experiment with adding a service category
  // in the admin UI without immediately exposing it to patients. Default off
  // so new customers don't accidentally surface in-progress configuration.
  // The admin UI is unaffected (it queries `admin-list-service-categories`,
  // not the patient-facing `get-service-categories`).
  dynamicServiceCategoriesEnabled: z.boolean().optional(),
  employeeChatEnabled: z.boolean().optional(),
  // When true, this deployment runs in custom-organizations mode: the billing app manages
  // non-insurance organizations (employers) and custom insurance organizations, and clinical
  // pickers source from them — employer pickers exclusively, insurance-carrier pickers (EHR and
  // Intake) alongside Oystehr's payer list. When false/omitted, the legacy clinical Employers
  // feature — with its Candid non-insurance payer sync — stays active, and insurance-carrier
  // pickers offer only Oystehr payers. Existing coverages/visits already referencing a custom
  // organization still resolve and display correctly either way. Per-deployment so customers can
  // migrate at different times.
  customOrganizationsEnabled: z.boolean().optional(),
});

export type FeatureFlagsConfig = z.infer<typeof FeatureFlagsConfigSchema>;
